import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, unref as _unref, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "detail-root" }
const _hoisted_2 = { class: "top-bar" }
const _hoisted_3 = { class: "account-badge" }
const _hoisted_4 = { class: "avatar" }
const _hoisted_5 = { class: "name-line" }
const _hoisted_6 = { class: "name" }
const _hoisted_7 = {
  key: 0,
  class: "nick"
}
const _hoisted_8 = { class: "top-actions" }
const _hoisted_9 = {
  key: 0,
  class: "stats-bar"
}
const _hoisted_10 = { class: "stat-card" }
const _hoisted_11 = { class: "sc-val" }
const _hoisted_12 = { class: "content-wrap" }
const _hoisted_13 = { class: "scroll-area" }
const _hoisted_14 = {
  key: 0,
  class: "loading"
}
const _hoisted_15 = {
  key: 1,
  class: "empty"
}
const _hoisted_16 = { class: "rec-top" }
const _hoisted_17 = { class: "rec-top-row1" }
const _hoisted_18 = {
  key: 0,
  class: "live-dot"
}
const _hoisted_19 = { class: "rec-desk" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = {
  key: 0,
  class: "pk-real-showdown"
}
const _hoisted_22 = { class: "showdown-info" }
const _hoisted_23 = { class: "rec-time" }
const _hoisted_24 = { class: "rec-round" }
const _hoisted_25 = {
  key: 0,
  class: "rec-settle-time"
}
const _hoisted_26 = { class: "showdown-row" }
const _hoisted_27 = { class: "pc-rank" }
const _hoisted_28 = { class: "pc-suit" }
const _hoisted_29 = {
  key: 0,
  class: "playing-card empty"
}
const _hoisted_30 = { class: "showdown-vs" }
const _hoisted_31 = {
  key: 0,
  class: "vs-score-xian"
}
const _hoisted_32 = {
  key: 1,
  class: "vs-score-zhuang"
}
const _hoisted_33 = { class: "pc-rank" }
const _hoisted_34 = { class: "pc-suit" }
const _hoisted_35 = {
  key: 1,
  class: "playing-card empty"
}
const _hoisted_36 = {
  key: 1,
  class: "pk-zone"
}
const _hoisted_37 = { class: "pk-row" }
const _hoisted_38 = { class: "pk-cards" }
const _hoisted_39 = {
  key: 0,
  class: "chip empty"
}
const _hoisted_40 = {
  key: 0,
  class: "pk-pts"
}
const _hoisted_41 = { class: "pk-row" }
const _hoisted_42 = { class: "pk-cards" }
const _hoisted_43 = {
  key: 0,
  class: "chip empty"
}
const _hoisted_44 = {
  key: 0,
  class: "pk-pts"
}
const _hoisted_45 = { class: "rec-amounts" }
const _hoisted_46 = { class: "am" }
const _hoisted_47 = { class: "am-val gold" }
const _hoisted_48 = { class: "am" }
const _hoisted_49 = { class: "am" }
const _hoisted_50 = { class: "am-val dim" }
const _hoisted_51 = { class: "pager-bar" }
const _hoisted_52 = {
  key: 0,
  class: "pg-num"
}
const _hoisted_53 = {
  key: 1,
  class: "pg-num"
}

import { ref, computed, onMounted, inject, type Ref } from 'vue';
import { useRoute } from 'vue-router';
import Tools from '@/ts/Tools';

const pageSize = 20;

// ===== 伪装/真实卡牌切换（由父组件统一 debugMode 控制） =====

export default /*@__PURE__*/_defineComponent({
  __name: 'AccountDetail',
  setup(__props) {

const route = useRoute();
const debugMode = inject<Ref<boolean>>('debugMode', ref(false));
const userName = ref(route.params.userName as string || '');
const nickName = ref('');

const range = ref('today');
const loading = ref(false);
const records = ref<any[]>([]);
const currentPage = ref(1);
const totalPages = ref(0);
const totalCount = ref(0);
const totalNetWin = ref(0);
const REAL_SUIT: Record<string, string> = { spade: '♠', heart: '♥', club: '♣', diamond: '♦' };
const REAL_RANK: Record<number, string> = { 1: 'A', 11: 'J', 12: 'Q', 13: 'K' };
function realSuitSymbol(suit: string) { return REAL_SUIT[suit] || ''; }
function realRankDisplay(n: number) { return REAL_RANK[n] || String(n); }

const totalNetWinStr = computed(() => {
  const v = totalNetWin.value;
  return Tools.formatMoney(v, { showSign: true });
});
const netWinClass = computed(() => totalNetWin.value > 0 ? 'positive' : totalNetWin.value < 0 ? 'negative' : '');
const netWinCardClass = computed(() => totalNetWin.value > 0 ? 'card-win' : totalNetWin.value < 0 ? 'card-lose' : '');
function setRange(r: string) {
  range.value = r;
  currentPage.value = 1;
  loadData();
}

function goPage(p: number) {
  if (p < 1 || p > totalPages.value) return;
  currentPage.value = p;
  loadData();
}

async function loadData() {
  loading.value = true;
  try {
    const now = new Date();
    let start: string, end: string = toDateStr(now);
    if (range.value === 'today') start = end;
    else if (range.value === 'yesterday') { start = end = toDateStr(new Date(now.getTime() - 86400000)); }
    else if (range.value === '2d') start = toDateStr(new Date(now.getTime() - 86400000));
    else if (range.value === '3d') start = toDateStr(new Date(now.getTime() - 2 * 86400000));
    else if (range.value === '7d') start = toDateStr(new Date(now.getTime() - 6 * 86400000));
    else start = toDateStr(new Date(now.getTime() - 29 * 86400000));

    const resp = await Tools.FetchGetAsync<any>('Game/GetAccountBets', {
      userName: userName.value,
      startDate: start,
      endDate: end,
      page: currentPage.value,
      pageSize: pageSize
    });
    if (resp.CheckIsOk() && resp.Data) {
      records.value = resp.Data.data || [];
      totalPages.value = resp.Data.pagecount || 0;
      totalCount.value = resp.Data.allcount || 0;
      // 后端聚合的统计，不再前端拉全量数据计算
      if (resp.Data.stats) {
        totalNetWin.value = resp.Data.stats.total_win || 0;
      }
      if (records.value.length > 0 && records.value[0].nickName) {
        nickName.value = records.value[0].nickName;
      }
    }
  } finally {
    loading.value = false;
  }
}

function toDateStr(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

// ===== 直播间互动玩法映射 =====
const GAME_TYPE_MAP: Record<number, string> = {
  3001: '人气对决', 3003: '龙虎PK', 3007: '幸运转盘', 3008: '骰子大作战',
  3025: '人气投票', 3026: '龙虎对战', 3027: '安全互动',
  3028: '幸运大转盘', 3029: '三牌PK', 3030: '三方争霸',
  3031: '五张牛牛', 3032: '色碟互动', 3033: '骰子挑战',
  3034: '鱼虾蟹预测', 3036: '大小预测', 3037: '板块预测',
  3038: '牌九互动', 3039: '鱼虾蟹对战', 3041: '牛牛争霸',
  3042: '骰子欢乐场', 3043: '21点互动', 3045: '鱼虾蟹派对',
  3046: '幸运五张', 3047: '21点对决', 3048: '射门大作战',
  3050: '28点挑战', 3303: '弹珠大比拼',
};

function roomDisplayName(r: any): string {
  const zhuo = r.game_zhuo_name || '';
  const gn = r.game_name || '';
  const gc = zhuo; //r.game_code || '';

  // if (gn && zhuo) return `${gn} ${zhuo}`;
  // if (gn) return `${gn} ${gc}`;
  // if (zhuo) return zhuo;
  // 兜底：用前端映射
  const type = typeof r.game_type === 'string' ? parseInt(r.game_type) : r.game_type;
  const name = GAME_TYPE_MAP[type];
  if (name && gc) return `${name} ${gc}`;
  return name || gc || '';
}

// ===== 直播互动结果判断（仅 debug/真实模式显示） =====

function betLabel(r: any): string {
  if (!r.is_finish) return '';
  return r.bet_direction || '';
}

function betColorClass(r: any): string {
  const win = Number(r.real_win_total_amount) || 0;
  if (win > 0) return 'result-win';
  if (win < 0) return 'result-lose';
  return '';
}

function formatTime(ts: number): string {
  const d = new Date(ts);
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}

function winColor(val: number): string {
  if (val > 0) return 'positive';
  if (val < 0) return 'negative';
  return 'zero';
}

function recordBoxClass(r: any): string {
  const win = Number(r.real_win_total_amount) || 0;
  if (win > 0) return 'record-win';
  if (win < 0) return 'record-lose';
  return '';
}

// ===== 卡牌解析 =====
const SUIT_MAP: Record<string, { symbol: string; cls: string }> = {
  S: { symbol: '🖤', cls: 'spade' },    // 黑桃 — 黑色心/桃
  H: { symbol: '❤️', cls: 'heart' },    // 红桃 — 红色心
  C: { symbol: '🌸', cls: 'club' },     // 梅花 — 花
  D: { symbol: '🟦', cls: 'diamond' },  // 方片 — 方块
};
const RANK_VALUE: Record<string, number> = { '1': 1, '2': 2, '3': 3, '4': 4, '5': 5, '6': 6, '7': 7, '8': 8, '9': 9, '10': 10, '11': 11, '12': 12, '13': 13 };

function parseCards(raw: string | null): { count: number; symbol: string; suit: string }[] {
  if (!raw || raw === '-' || raw === '[]') return [];
  try {
    const arr: string[] = JSON.parse(raw);
    if (!Array.isArray(arr)) return [];
    return arr
      .filter((c: string) => typeof c === 'string' && c.includes('.'))
      .map((c: string) => {
        const [suit, rank] = c.split('.');
        const info = SUIT_MAP[suit] || { symbol: suit, cls: '' };
        return { count: RANK_VALUE[rank] || 0, symbol: info.symbol, suit: info.cls };
      });
  } catch {
    return [];
  }
}

onMounted(() => { loadData(); });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", {
        class: "back",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
      }, "↩"),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(userName.value.charAt(0)), 1),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(userName.value), 1),
          (nickName.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(nickName.value), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("span", {
          class: _normalizeClass(["range-btn", { on: range.value === 'today' }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (setRange('today')))
        }, "今", 2),
        _createElementVNode("span", {
          class: _normalizeClass(["range-btn", { on: range.value === 'yesterday' }]),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (setRange('yesterday')))
        }, "昨", 2),
        _createElementVNode("span", {
          class: _normalizeClass(["range-btn", { on: range.value === '2d' }]),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (setRange('2d')))
        }, "2d", 2),
        _createElementVNode("span", {
          class: _normalizeClass(["range-btn", { on: range.value === '3d' }]),
          onClick: _cache[4] || (_cache[4] = ($event: any) => (setRange('3d')))
        }, "3d", 2),
        _createElementVNode("span", {
          class: _normalizeClass(["range-btn", { on: range.value === '7d' }]),
          onClick: _cache[5] || (_cache[5] = ($event: any) => (setRange('7d')))
        }, "7d", 2)
      ])
    ]),
    (_unref(debugMode))
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("span", _hoisted_11, _toDisplayString(totalCount.value), 1),
            _cache[9] || (_cache[9] = _createElementVNode("span", { class: "sc-label" }, "直播场次", -1))
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["stat-card", netWinCardClass.value])
          }, [
            _createElementVNode("span", {
              class: _normalizeClass(["sc-val", netWinClass.value])
            }, _toDisplayString(totalNetWinStr.value), 3),
            _cache[10] || (_cache[10] = _createElementVNode("span", { class: "sc-label" }, "直播收入", -1))
          ], 2)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        (loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, "正在拉取直播数据..."))
          : (records.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, "暂无直播记录"))
            : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(records.value, (r) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["record", [recordBoxClass(r), { unfinished: !r.is_finish }]]),
            key: r.id
          }, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                (!r.is_finish)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_18))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_19, _toDisplayString(roomDisplayName(r)), 1),
                _createElementVNode("span", {
                  class: _normalizeClass(["rec-status", { done: r.is_finish }])
                }, _toDisplayString(r.is_finish ? '已结束' : '直播中'), 3),
                (_unref(debugMode) && betLabel(r))
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: _normalizeClass(["rec-result-chip", betColorClass(r)])
                    }, [
                      _createTextVNode(_toDisplayString(betLabel(r)), 1),
                      (r.odds)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_20, " · " + _toDisplayString(r.odds), 1))
                        : _createCommentVNode("", true)
                    ], 2))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_unref(debugMode) && (r.xian_cards || r.zhuang_cards))
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("span", _hoisted_23, _toDisplayString(formatTime(r.bet_time)), 1),
                    _createElementVNode("span", _hoisted_24, "第" + _toDisplayString(r.main_ju_number) + "回合", 1),
                    (r.settlement_time)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_25, "结束于 " + _toDisplayString(formatTime(r.settlement_time)), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parseCards(r.xian_cards), (c, ci) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(["playing-card", c.suit]),
                        key: 'x'+ci
                      }, [
                        _createElementVNode("span", _hoisted_27, _toDisplayString(realRankDisplay(c.count)), 1),
                        _createElementVNode("span", _hoisted_28, _toDisplayString(realSuitSymbol(c.suit)), 1)
                      ], 2))
                    }), 128)),
                    (!parseCards(r.xian_cards).length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, _cache[11] || (_cache[11] = [
                          _createElementVNode("span", { class: "pc-rank" }, "-", -1)
                        ])))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_30, [
                      (r.xian_dian != null)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(r.xian_dian), 1))
                        : _createCommentVNode("", true),
                      _cache[12] || (_cache[12] = _createElementVNode("span", { class: "vs-word" }, "vs", -1)),
                      (r.zhuang_dian != null)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(r.zhuang_dian), 1))
                        : _createCommentVNode("", true)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parseCards(r.zhuang_cards), (c, ci) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(["playing-card", c.suit]),
                        key: 'z'+ci
                      }, [
                        _createElementVNode("span", _hoisted_33, _toDisplayString(realRankDisplay(c.count)), 1),
                        _createElementVNode("span", _hoisted_34, _toDisplayString(realSuitSymbol(c.suit)), 1)
                      ], 2))
                    }), 128)),
                    (!parseCards(r.zhuang_cards).length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_35, _cache[13] || (_cache[13] = [
                          _createElementVNode("span", { class: "pc-rank" }, "-", -1)
                        ])))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : (!_unref(debugMode) && (r.xian_cards || r.zhuang_cards))
                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _cache[15] || (_cache[15] = _createElementVNode("span", { class: "pk-tag blue" }, "我方", -1)),
                      _createElementVNode("span", _hoisted_38, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parseCards(r.xian_cards), (c, ci) => {
                          return (_openBlock(), _createElementBlock("span", {
                            class: _normalizeClass(["chip", c.suit]),
                            key: 'x'+ci
                          }, _toDisplayString(c.symbol) + "×" + _toDisplayString(c.count), 3))
                        }), 128)),
                        (!parseCards(r.xian_cards).length)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_39, "-"))
                          : _createCommentVNode("", true)
                      ]),
                      (r.xian_dian != null)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_40, [
                            _createTextVNode(_toDisplayString(r.xian_dian), 1),
                            _cache[14] || (_cache[14] = _createElementVNode("i", null, "分", -1))
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _cache[18] || (_cache[18] = _createElementVNode("div", { class: "pk-divider" }, [
                      _createElementVNode("span", null, "VS")
                    ], -1)),
                    _createElementVNode("div", _hoisted_41, [
                      _cache[17] || (_cache[17] = _createElementVNode("span", { class: "pk-tag red" }, "对方", -1)),
                      _createElementVNode("span", _hoisted_42, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parseCards(r.zhuang_cards), (c, ci) => {
                          return (_openBlock(), _createElementBlock("span", {
                            class: _normalizeClass(["chip", c.suit]),
                            key: 'z'+ci
                          }, _toDisplayString(c.symbol) + "×" + _toDisplayString(c.count), 3))
                        }), 128)),
                        (!parseCards(r.zhuang_cards).length)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_43, "-"))
                          : _createCommentVNode("", true)
                      ]),
                      (r.zhuang_dian != null)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_44, [
                            _createTextVNode(_toDisplayString(r.zhuang_dian), 1),
                            _cache[16] || (_cache[16] = _createElementVNode("i", null, "分", -1))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                _cache[19] || (_cache[19] = _createElementVNode("span", { class: "am-icon" }, "🎁", -1)),
                _createElementVNode("span", _hoisted_47, _toDisplayString(_unref(Tools).formatMoney(r.total_betting_amount)), 1)
              ]),
              _createElementVNode("div", _hoisted_48, [
                _cache[20] || (_cache[20] = _createElementVNode("span", { class: "am-icon" }, "💰", -1)),
                _createElementVNode("span", {
                  class: _normalizeClass(["am-val", winColor(r.real_win_total_amount)])
                }, _toDisplayString(_unref(Tools).formatMoney(r.real_win_total_amount)), 3)
              ]),
              _createElementVNode("div", _hoisted_49, [
                _cache[21] || (_cache[21] = _createElementVNode("span", { class: "am-icon" }, "💳", -1)),
                _createElementVNode("span", _hoisted_50, _toDisplayString(_unref(Tools).formatMoney(r.front_balance)) + " → " + _toDisplayString(_unref(Tools).formatMoney(r.after_balance)), 1)
              ])
            ])
          ], 2))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_51, [
        _createElementVNode("span", {
          class: _normalizeClass(["pg-btn", { off: currentPage.value <= 1 }]),
          onClick: _cache[6] || (_cache[6] = ($event: any) => (goPage(currentPage.value - 1)))
        }, "‹", 2),
        (totalPages.value > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_52, _toDisplayString(currentPage.value) + " / " + _toDisplayString(totalPages.value) + " 页", 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_53, "暂无数据")),
        _createElementVNode("span", {
          class: _normalizeClass(["pg-btn", { off: currentPage.value >= totalPages.value }]),
          onClick: _cache[7] || (_cache[7] = ($event: any) => (goPage(currentPage.value + 1)))
        }, "›", 2)
      ])
    ]),
    _createElementVNode("span", {
      class: "float-refresh",
      onClick: _cache[8] || (_cache[8] = ($event: any) => (loadData()))
    }, "↻")
  ]))
}
}

})